module.exports = __webpack_public_path__ + "img/23.cbe17867.png";